/*

{{- $metersToFeet := dict "15" 50 "10" 30 "25" 80 -}}
{{- $fromM := .Get 0 -}}
{{- $toM := .Get 1 -}}
{{- $isEnglish := eq "en" $.Site.Language.Lang -}}
{{- $fromF := math.Round (mul $fromM 3.28084) -}}
{{- if (isset $metersToFeet (string $fromM)) -}}
    {{- $fromF = index $metersToFeet (string $fromM) -}}
{{- end -}}
    {{- if $toM -}}
        {{- $toF := math.Round (mul $toM 3.28084) -}}
        {{- if (isset $metersToFeet (string $toM)) -}}
            {{- $toF = index $metersToFeet (string $toM) -}}
        {{- end -}}
        {{ $fromM }} {{ i18n "temp-to" | safeHTML }} {{$toM}} m {{ if $isEnglish }}({{$fromF}} {{ i18n "temp-to" | safeHTML }} {{$toF}} ft){{ end }}
    {{- else -}}
    {{- i18n "meters" $fromM -}} {{- if $isEnglish -}}({{- i18n "feet" $fromF -}}){{- end -}}
{{- end -}}

*/

import {useTranslation} from "next-i18next";

interface MetersProps {
    distance: string;
    to?: string;
}

const common: any = {
    "15": 50,
    "10": 30,
    "25": 80
}

export function Meters({distance, to}: MetersProps) {

    const {t, i18n} = useTranslation();

    const isEnglish = i18n.language == "en"

    let output = null
    const fromM = parseInt(distance)
    const toM = to
    const fromF = common[fromM] ?? Math.round(3.28084 * fromM)

    if (toM) {
        const toF = common[toM] ?? Math.round(3.28084 * parseFloat(toM))

        // {{ $fromM }} {{ i18n "temp-to" | safeHTML }} {{$toM}} m {{ if $isEnglish }}({{$fromF}} {{ i18n "temp-to" | safeHTML }} {{$toF}} ft){{ end }}
        output = <>{fromM} {t("temp-to")} {toM} m {isEnglish ? <>({fromF} {t("temp-to")} {toF} ft)</> : null}</>
    } else {
        // {{- i18n "meters" $fromM -}} {{- if $isEnglish -}}({{- i18n "feet" $fromF -}}){{- end -}}
        output = <>{t("meters", {count: fromM})} {isEnglish ? <>({fromF} ft)</> : null}</>
    }


    return <span style={{ }}>{output}</span>;
}
